import React from "react";
import { useParams, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { CustomTooltip } from "../../components/CustomTooltip";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import Pagination from "../Constant/Pagination";
import { getBusActivePassesApi } from "../../services/TransportService";
import { useState, useEffect } from "react";
import format from "date-fns/format";
import { PiExportBold } from "react-icons/pi";
import { CancelRequest } from "../../services/AxiosInstance";
import { toInitials } from "../../utilities";
const BusActiveEmployee = ({ busId }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [exportloading, setExportloading] = useState(false);
  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
  });
  const getdata = () => {
    setLoading(true);
    getBusActivePassesApi(busId || id, param)
      .then((res) => {
        setData(res?.data?.results);
        setTotal(res.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getdata();
  }, [param, id, busId]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  return (
    <div>
      <div className="d-flex justify-content-end px-3 mb-2">
        <div className="d-flex gap-1">
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : data.length === 0 ? (
        <div className="p-2 text-center">There are no records found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover fs-6 align-middle mb-0">
            <thead className="custom-thead table-light">
              <tr>
                <th style={{minWidth:'180px'}}>Employee</th>
                <th>Gender</th>
                <th>Route</th>
                <th>Shift</th>
                <th>Stop</th>
                <th>Activate</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div
                          className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-1"
                          style={{ width: 33, height: 33 }}
                        >
                          <span className="fw-medium">
                            {toInitials(row?.employee?.name)}
                          </span>
                        </div>
                        <div>
                          <Link
                            to={`/employee/${row?.employee.id}`}
                            className="fw-medium text-uppercase text-primary d-block"
                            style={{fontSize:'0.9rem'}}
                          >
                            {row?.employee.name}
                          </Link>
                          <Link to={`/employee/${row?.employee.id}`}>
                            <span className="text-secondary fw-medium" style={{fontSize:'0.8rem'}}>
                              {row?.employee.mobile_number}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>{row?.employee?.gender || "N/A"}</td>
                    <td>{row?.route?.name || "N/A"}</td>
                    <td>{row?.shift?.name || "N/A"}</td>
                    <td>{row?.stop?.name}</td>
                    <td>
                      {row?.start_date
                        ? format(new Date(row.start_date), "d MMMM yyyy")
                        : "-"}{" "}
                      {/* To{" "}
                      {row?.end_date
                        ? format(new Date(row.end_date), "d MMMM yyyy")
                        : "-"} */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {!loading && data && data.length > 0 && (
        <div className="px-2 border-top">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default BusActiveEmployee;
